import { render } from "./buyer.vue?vue&type=template&id=526f132c&scoped=true"
import script from "./buyer.vue?vue&type=script&lang=js"
export * from "./buyer.vue?vue&type=script&lang=js"

import "./buyer.vue?vue&type=style&index=0&id=526f132c&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-526f132c"]])

export default __exports__